import React from 'react';
import PropTypes from 'prop-types';
import Select from '../select';
import Button from '../button';

export default class MultiSelect extends React.Component {
  static displayName = 'MultiSelect';
  static propTypes = {
    items: PropTypes.array,
    itemClasses: PropTypes.string,
    removeIconClasses: PropTypes.string,
    selectOptions: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
    onItemSelect: PropTypes.func,
    onItemRemove: PropTypes.func,
    onItemAdd: PropTypes.func,
  };
  static defaultProps = {
    items: [],
    itemClasses: '',
    removeIconClasses: '',
    selectOptions: [],
    className: '',
    onItemSelect: function () {},
    onItemRemove: function () {},
    onItemAdd: function () {},
  };

  selectChanged(index, value) {
    this.props.onItemSelect(index, value);
  }

  removeClicked(index) {
    this.props.onItemRemove(index);
  }

  buttonClicked(e) {
    e.preventDefault();
    this.props.onItemAdd();
  }

  renderRemoveIcon(index) {
    return (
      <div
        className={this.props.removeIconClasses}
        onClick={this.removeClicked.bind(this, index)}
      >
        <span className="af-icon af-xCircle" />
      </div>
    );
  }

  renderSelect(item, index, items) {
    return (
      <div key={index} className={this.props.itemClasses}>
        <Select
          options={this.props.selectOptions}
          value={item}
          onChange={this.selectChanged.bind(this, index)}
          dataTestId={this.props.dataTestId}
        />

        {items.length > 1 ? this.renderRemoveIcon(index) : null}
      </div>
    );
  }

  render() {
    return (
      <div className={`MultiSelect ${this.props.className}`}>
        {this.props.items.map(this.renderSelect.bind(this))}
        <Button
          label="+"
          icon=""
          theme="PlusIcon"
          onClick={this.buttonClicked.bind(this)}
          dataTestId="add-new-icon"
        />
      </div>
    );
  }
}
